import React from 'react'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import CreateAccountForBookingLayout from 'pages/schedule/SelectStudent/CreateAccountForBookingLayout.js'
import ReservationsHeaderWrapper from '../reservations-header-wrapper'
import ConfirmMemberNumberInput from './confirm-member-number-input'
import { useQuery } from '@apollo/client'
import { GET_STUDENTS } from '../queries'
import Error from 'components/error'
import { getPracticeSessionContent } from '../index'

export const findStudentByExternalID = (students, externalId) => {
  return students?.find(student =>
    student?.representatives.some(
      r =>
        r?.relationshipType === 'SELF' && r?.contact?.externalId === externalId,
    ),
  )?.id
}

const SelectStudent = ({
  academy,
  practiceSession,
  isLoggedIn,
  externalId,
}) => {
  const history = useHistory()
  const { pathname } = useLocation()
  const [memberNumber, setMemberNumber] = React.useState('')
  const [memberNumberError, setMemberNumberError] = React.useState('')
  const currentUrl = window.location.pathname + window.location.search

  const { membershipVerification } = getPracticeSessionContent(
    practiceSession?.id,
  )

  const validateMemberNumber = () => {
    if (memberNumber.length !== membershipVerification.fieldLength) {
      setMemberNumberError('Please provide a valid member number.')
    } else if (memberNumber.length === membershipVerification.fieldLength) {
      setMemberNumberError('')
    }
  }

  const handleNext = selfStudentId => {
    validateMemberNumber()
    if (memberNumber.length === membershipVerification.fieldLength) {
      history.push(
        `${currentUrl}&studentId=${selfStudentId}&memberNumber=${memberNumber}`,
      )
    }
  }

  const { data, loading, error } = useQuery(GET_STUDENTS, {
    skip: !isLoggedIn,
  })

  if (loading) return <LinearProgress />
  if (error) return <Error error={error} />

  const students = data?.currentUser?.students
  const selfStudentId = findStudentByExternalID(students, externalId)

  return (
    <Grid container>
      <ReservationsHeaderWrapper
        academy={academy}
        selectedPracticeSession={practiceSession}
        currentStep={2}
        totalSteps={4}
        previousUrl={pathname}
      >
        <Grid item xs={12}>
          {isLoggedIn ? (
            <>
              <ConfirmMemberNumberInput
                memberNumber={memberNumber}
                setMemberNumber={setMemberNumber}
                memberNumberError={memberNumberError}
                fieldLength={membershipVerification.fieldLength}
              />
              <Button
                disabled={!memberNumber}
                variant="contained"
                color="primary"
                onClick={() => handleNext(selfStudentId)}
              >
                Next
              </Button>
            </>
          ) : (
            <CreateAccountForBookingLayout showDescription={false} />
          )}
        </Grid>
      </ReservationsHeaderWrapper>
    </Grid>
  )
}

SelectStudent.propTypes = {
  academy: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  externalId: PropTypes.string,
}

export default SelectStudent
